import { useState } from 'react';
import { PremiumBanner } from './ui/PremiumBanner';
import { getTelegram, isTelegramAvailable } from '../utils/telegramAdapter';

const CHANNEL_URL = 'https://t.me/headman_salon';

type SubscribeScreenProps = {
  onVerified?: () => void;
};

export function SubscribeScreen({ onVerified }: SubscribeScreenProps) {
  const [showBanner, setShowBanner] = useState(false);
  const [isChecking, setIsChecking] = useState(false);

  const handleSubscribe = () => {
    if (isTelegramAvailable() && getTelegram().openTelegramLink) {
      getTelegram().openTelegramLink?.(CHANNEL_URL);
      return;
    }

    window.open(CHANNEL_URL, '_blank', 'noopener,noreferrer');
  };

  const handleCheckSubscription = async () => {
    setIsChecking(true);
    setShowBanner(false);

    const initData = isTelegramAvailable() ? (getTelegram().initData || '') : '';
    if (!initData) {
      setIsChecking(false);
      return;
    }

    try {
      const response = await fetch('/api/auth/subscription', {
        headers: {
          'X-Telegram-InitData': initData,
        },
      });

      if (response.ok) {
        onVerified?.();
      } else if (response.status === 403) {
        setShowBanner(true);
        setTimeout(() => setShowBanner(false), 4500);
      }
    } catch (error) {
      console.error('Subscription check failed:', error);
    } finally {
      setIsChecking(false);
    }
  };

  return (
    <div className="min-h-dvh bg-sheriff-bg flex items-center justify-center p-6">
      <PremiumBanner
        show={showBanner}
        onClose={() => setShowBanner(false)}
        variant="top"
      />

      <div className="max-w-md w-full">
        <div className="bg-gradient-to-br from-[#0E0E0E] to-[#141414] rounded-3xl p-8 border border-white/[0.08] shadow-[inset_0_1px_0_rgba(255,255,255,0.03),0_8px_32px_rgba(0,0,0,0.4)]">
          <div className="text-center mb-8">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-[#C9A24D]/20 to-[#C9A24D]/5 flex items-center justify-center border border-[#C9A24D]/20">
              <svg
                className="w-10 h-10 text-[#C9A24D]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                />
              </svg>
            </div>
            <h1 className="text-2xl font-semibold text-white/95 mb-3">
              Подписка обязательна
            </h1>
            <p className="text-white/65 text-base leading-relaxed">
              Чтобы пользоваться AI-студией Headman, подпишитесь на канал.
            </p>
          </div>

          <div className="space-y-3">
            <button
              onClick={handleSubscribe}
              className="w-full py-3.5 px-6 rounded-2xl bg-gradient-to-br from-[#0E0E0E] to-[#141414] text-white/95 text-base font-medium border border-white/[0.08] shadow-[inset_0_1px_0_rgba(255,255,255,0.03),0_8px_32px_rgba(0,0,0,0.4)] transition-all duration-200 hover:scale-[1.01] active:scale-[0.98]"
            >
              Подписаться
            </button>

            <button
              onClick={handleCheckSubscription}
              disabled={isChecking}
              className="w-full py-3.5 px-6 rounded-2xl text-white/75 text-base font-medium transition-all duration-200 hover:text-white/90 hover:bg-white/[0.03] disabled:opacity-50"
            >
              {isChecking ? 'Проверяю...' : 'Я подписался, проверить'}
            </button>
          </div>

          <div className="mt-6 pt-6 border-t border-white/[0.06]">
            <p className="text-white/45 text-sm text-center">
              После подписки нажмите «Я подписался, проверить».
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
